import React, { useEffect, useState } from "react";
import { Table, Button, Tag, message, Space, Card, Layout, Select, Typography } from "antd";
import axios from "axios";
import { BASE_URL } from "../../Config";
import Sidebar from "../../Components/Sidebar";
import {
  MenuOutlined,
} from "@ant-design/icons";
const { Header } = Layout;
const { Text } = Typography;

const UserAsanaApproval = () => {
  const [asanas, setAsanas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const admin = JSON.parse(localStorage.getItem("admin"));
  const role = admin?.role || "admin";

  useEffect(() => {
    const checkScreen = () => setIsMobile(window.innerWidth <= 768);
    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  const fetchAsanas = async () => {
    try {
      setLoading(true);
      const token = sessionStorage.getItem("token");

      const res = await axios.get(`${BASE_URL}/userasanas`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setAsanas(res.data.asanas || []);
    } catch (err) {
      message.error("Failed to load user asanas");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAsanas();
  }, []);

  const approveAsana = async (id) => {
    try {
      const token = sessionStorage.getItem("token");

      await axios.put(
        `${BASE_URL}/userasanas/approve/${id}`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      message.success("Asana approved successfully!");
      fetchAsanas();
    } catch (error) {
      message.error("Failed to approve");
    }
  };

  const rejectAsana = async (id) => {
    try {
      const token = sessionStorage.getItem("token");

      await axios.put(
        `${BASE_URL}/userasanas/reject/${id}`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      message.success("Asana rejected");
      fetchAsanas();
    } catch (error) {
      message.error("Failed to reject");
    }
  };

  const columns = [
    {
      title: "User",
      dataIndex: "userId",
      render: (user) => <span>{user?.name || "Unknown User"}</span>,
    },
    {
      title: "Asana Name",
      dataIndex: "name",
      render: (_, row) => <b>{row.name}</b>,
    },
    {
      title: "Level",
      dataIndex: "level",
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (status) => {
        const color =
          status === "pending"
            ? "orange"
            : status === "approved"
              ? "green"
              : "red";

        return <Tag color={color}>{status.toUpperCase()}</Tag>;
      },
    },
    {
      title: "Actions",
      render: (_, row) => (
        <Space>
          {row.status === "pending" && (
            <>
              <Button type="primary" onClick={() => approveAsana(row._id)}>
                Approve
              </Button>

              <Button danger onClick={() => rejectAsana(row._id)}>
                Reject
              </Button>
            </>
          )}

          {row.status !== "pending" && (
            <Tag color={row.status === "approved" ? "green" : "red"}>
              {row.status}
            </Tag>
          )}
        </Space>
      ),
    },
  ];

  const MobileAsanaCard = ({ item }) => {
    const statusColor =
      item.status === "pending"
        ? "orange"
        : item.status === "approved"
          ? "green"
          : "red";

    return (
      <Card
        style={{
          marginBottom: 16,
          borderRadius: 16,
        }}
        bodyStyle={{ padding: 16 }}
      >
        {/* Top Row */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div>
            <div style={{ fontSize: 12, color: "#888" }}>
              {item.userId?.name || "Unknown User"}
            </div>

            <div
              style={{
                fontSize: 18,
                fontWeight: 600,
              }}
            >
              {item.name}
            </div>
          </div>

          <Tag style={{height: "fit-content"}} color={statusColor}>
            {item.status.toUpperCase()}
          </Tag>
        </div>

        {/* Level */}
        <div style={{ marginTop: 10 }}>
          <span style={{ color: "#888" }}>Level: </span>
          <Tag color="blue">{item.level}</Tag>
        </div>

        {/* Actions */}
        <div
          style={{
            marginTop: 16,
            display: "flex",
            justifyContent: "flex-end",
            gap: 8,
          }}
        >
          {item.status === "pending" && (
            <>
              <Button
                type="primary"
                onClick={() => approveAsana(item._id)}
              >
                Approve
              </Button>

              <Button
                danger
                onClick={() => rejectAsana(item._id)}
              >
                Reject
              </Button>
            </>
          )}
        </div>
      </Card>
    );
  };

  return (
    <Layout style={{ minHeight: "100vh", background: "#f5f7fa" }}>
      <Sidebar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        mobileOpen={mobileOpen}
        setMobileOpen={setMobileOpen}
        isMobile={isMobile}
        collapsedWidth="0"
      />

      <Layout
        className="main-layout"
        style={{
          marginLeft: isMobile ? 0 : collapsed ? 0 : 240,
          transition: "0.3s",
          padding: isMobile ? 10 : 20,
        }}
      >
        <Header
          className="MainHeader"
        >
          {isMobile && (
            <Button
              type="text"
              icon={<MenuOutlined />}
              onClick={() => setMobileOpen(true)}
              style={{ fontSize: 18, marginRight: 12 }}
            />
          )}
          <div style={{ flex: 1 }}>
            <Text style={{ fontSize: 20, fontWeight: "bold" }}>All Asanas</Text>
          </div>
        </Header>
        <Card
          title="User Submitted Asanas"
          style={{ margin: 20, borderRadius: 12, boxShadow: "0 4px 12px #ddd" }}
        >
          {isMobile ? (
            loading ? (
              <p>Loading...</p>
            ) : (
              asanas.map((item) => (
                <MobileAsanaCard
                  key={item._id}
                  item={item}
                />
              ))
            )
          ) : (
            <Table
              columns={columns}
              dataSource={asanas}
              rowKey="_id"
              loading={loading}
            />
          )}
        </Card>
      </Layout>
    </Layout>
  );
};

export default UserAsanaApproval;
